import React, { useState, useEffect } from "react";
import { func, object } from "prop-types";

import "./checkout-modal.m.css";

const currencyLabels = {
  EUR: "€",
};

export const CheckoutModal = ({ member, setActiveTab, initPaytrailPayment, selectedPlan, validateCoupon, selectedSubscriptionGroup=null }) => {
  const [couponCode, setCouponCode] = useState("");
  const [showCouponCode, setShowCouponCode] = useState(false);
  const [isCouponApplied, setIsCouponApplied] = useState("");
  const [plan, setPlan] = useState(selectedPlan.plan);

  /*useEffect(() => {
    const handleMessage = (event) => {
      console.log("Received message:", event);
      console.log("event.origin:", event.origin);
      console.log("event.data:", event.data);

      if (event.origin !== window.origin) return;
      const queryParams = new URLSearchParams(event.data);
      if (queryParams.has('signature')) {
        window.location.href = "/";
    }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);*/

  return (
    <div styleName="checkout-wrapper">
    <div styleName="pricing-card">
      <div>
        <div styleName="pricing-header"><h2>TILAA DEI PLUS</h2></div>
        <div styleName="checkout-container">
          {member && (
            <div styleName="row-wrapper">
              <div>
                <div styleName="label">Tili</div>
                <span style={{ color: 'white' }}>{member.name}</span>
                <span styleName="not-you-btn" onClick={() => setActiveTab("login")}>
                Etkö sinä?
                </span>
              </div>
            </div>
          )}
          <div styleName="row-wrapper">
            <div styleName="label">Tilauksen tiedot:</div>
            <div styleName="plan-preview">
              <div>
                <div>
                  {selectedSubscriptionGroup
                    ? `${selectedSubscriptionGroup.charAt(0).toUpperCase()}${selectedSubscriptionGroup.slice(1).toLowerCase()}, `
                    : ''}
                  {plan.title}
                </div>
                {/*<div styleName="price">
                  {currencyLabels?.[plan?.price_currency] && plan?.price_cents
                    ? `${currencyLabels[plan.price_currency]} ${plan.price_cents / 100}`
                    : ""}
                  </div>*/}
              </div>
            </div>
            {/*<div styleName="validity">{`Valid for ${plan.duration_length} ${
              plan.duration_length === 1
                ? plan.duration_unit.substring(0, plan.duration_unit.length - 1)
                : plan.duration_unit
            }`}</div>*/}
            {/*<div styleName="plan-and-coupon-btns">
              <div styleName="change-plan-btn" onClick={() => setActiveTab("subscription")}>
              Muuta suunnitelmaa
              </div>
              {!showCouponCode && (
                <div styleName="add-coupon-code-btn" onClick={() => setShowCouponCode(true)}>
                  Lisää kuponkikoodi
                </div>
              )}
            </div>*/}
            {showCouponCode && (
              <div styleName="row-wrapper">
                <div styleName="coupon-code-label">Kuponkikoodi</div>
                <div styleName="coupon-apply">
                  <input
                    styleName="coupon-code-input"
                    value={couponCode}
                    type="text"
                    onChange={(e) => setCouponCode(e.target.value)}
                  />
                  <div
                    onClick={() => {
                      validateCoupon(plan.id, couponCode)
                        .then((res) => {
                          if (res.valid) {
                            const updatedPlan = { ...plan };
                            updatedPlan.coupon_code = couponCode;
                            updatedPlan.discounted_price_cents = res.discount_details.discounted_price_cents;
                            updatedPlan.coupon_discount = res.discount_details.value;
                            setIsCouponApplied("applied");
                            setPlan(updatedPlan);
                          } else {
                            setIsCouponApplied("failed");
                          }
                        })
                        .catch((err) => console.error(`Coupon code error: ${err}`));
                    }}
                    styleName="apply-coupon-btn"
                  >
                    Käytä
                  </div>
                </div>
              </div>
            )}
            {isCouponApplied === "applied" && (
              <div styleName="amount-saved">{`You saved ${currencyLabels[plan.price_currency]} ${
                (plan.price_cents - plan.discounted_price_cents) / 100
              }/-`}</div>
            )}
            {isCouponApplied === "failed" && <div styleName="coupon-error">Tämä kuponkikoodi on virheellinen</div>}
          </div>
          <div styleName="row-wrapper">
            <div styleName="total-payment">
              <div styleName="label">Maksamaan</div>
              <div styleName="total-payment-price-box" style={{lineHeight: "23px"}}>{`${
                (plan.discounted_price_cents !== undefined
                  ? (plan.discounted_price_cents / 100)
                  : (plan.price_cents / 100)
                ).toFixed(2).replace('.', ',')
              } ${currencyLabels[plan.price_currency]}`}</div>
            </div>
          </div>
          <div>
            <div styleName="row-wrapper">
              <div styleName="label">Maksutapa</div>
              <input type={"radio"} id={"credit-debit-cards"} value={"razorpay"} checked />
              <label styleName="radio-label" htmlFor="credit-debit-cards">
                Luotto-/pankkikortit
              </label>
            </div>
            <div styleName="row-wrapper" style={{marginBottom: "20px"}}>
              <div styleName="pricing-button-wrapper">
                <button
                  styleName="pricing-button"
                  onClick={async () => {
                    const updatedPlan = JSON.parse(JSON.stringify(plan));
                    updatedPlan.coupon_code = couponCode;
                    const paytrailOptions = {
                      selectedPlan: updatedPlan,
                      planType: "standard",
                      returnUrl: `${window.location.origin}/paytrail-success.html`,
                      cancelUrl: `${window.location.origin}/paytrail-cancel.html`,
                    };

                    try {
                      const paymentResponse = await initPaytrailPayment(paytrailOptions);

                      if (paymentResponse?.subscription?.id) {
                        window.location.href = `/tilaus-onnistui`;
                      } else {
                        window.location.href = `/tilaus-virhe`;
                      }
                    } catch (error) {
                      console.log(error);
                      console.log("Payment response:", error?.error?.["payment.from_gateway"]?.[0]?.success);
                      console.log("error message output:" + error?.message);

                      // payment window closed use-case
                      if (error?.message?.toLowerCase() === "payment window closed by user") {
                        console.log("payment window is closed by the user. do nothing.");
                        return;
                      }

                      // payment failed use-case
                      if (error?.error?.["payment.from_gateway"]?.[0]?.success === false) {
                        console.log("failed payment use-case triggered.");
                        window.location.href = `/tilaus-virhe`;
                      }
                    }
                  }}
                >
                  Maksamaan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div styleName="bottom-red-border"></div>
    </div>
    </div>
  );
};

CheckoutModal.propTypes = {
  member: object,
  setActiveTab: func,
  initPaytrailPayment: func,
  selectedPlan: object,
  validateCoupon: func,
};
